import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Dropdown.module.css';

// Menu renders via a portal to document.body (like Modal.jsx) so it isn't
// clipped by an ancestor's `overflow: hidden` — e.g. Campaigns.module.css's
// .tableWrap needs that overflow for its rounded corners, which otherwise
// clips an in-place absolutely-positioned menu.
class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, coords: null };
    this.wrapRef = React.createRef();
    this.menuRef = null;
    this.handleOutside = this.handleOutside.bind(this);
    this.reposition = this.reposition.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutside);
    window.addEventListener('resize', this.reposition);
    window.addEventListener('scroll', this.reposition, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutside);
    window.removeEventListener('resize', this.reposition);
    window.removeEventListener('scroll', this.reposition, true);
  }

  handleOutside(e) {
    const insideTrigger = this.wrapRef.current && this.wrapRef.current.contains(e.target);
    const insideMenu = this.menuRef && this.menuRef.contains(e.target);
    if (!insideTrigger && !insideMenu) this.setState({ open: false });
  }

  computeCoords() {
    const rect = this.wrapRef.current.getBoundingClientRect();
    const { align = 'left' } = this.props;
    return {
      top: rect.bottom + 4,
      left: align === 'right' ? undefined : rect.left,
      right: align === 'right' ? window.innerWidth - rect.right : undefined,
    };
  }

  reposition() {
    if (this.state.open) this.setState({ coords: this.computeCoords() });
  }

  toggle() {
    this.setState((s) => (s.open ? { open: false } : { open: true, coords: this.computeCoords() }));
  }

  render() {
    const { trigger, items = [] } = this.props;
    const { open, coords } = this.state;

    return (
      <div className={styles.wrap} ref={this.wrapRef}>
        <div onClick={this.toggle}>{trigger}</div>
        {open && coords && ReactDOM.createPortal(
          <div
            ref={(el) => { this.menuRef = el; }}
            className={styles.menu}
            style={{ position: 'fixed', top: coords.top, left: coords.left, right: coords.right }}
          >
            {items.map((item, i) => {
              if (item.divider) return <div key={i} className={styles.divider} />;
              return (
                <div
                  key={i}
                  className={[styles.item, item.danger ? styles.danger : ''].join(' ')}
                  onClick={() => { item.onClick && item.onClick(); this.setState({ open: false }); }}
                >
                  {item.icon && <span>{item.icon}</span>}
                  {item.label}
                </div>
              );
            })}
          </div>,
          document.body
        )}
      </div>
    );
  }
}

export default Dropdown;
